var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountAddresses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61813 5.00348C2.61695 3.76001 3.62466 2.75136 4.86812 2.75136H21.1258L21.1221 19.0019C21.1218 20.2443 20.1146 21.2514 18.8721 21.2514H4.88132C3.6395 21.2514 2.63249 20.2453 2.63132 19.0035L2.61813 5.00348Z",
    stroke: "#404553",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1429 14.8742C14.5952 14.4219 14.8749 13.7969 14.8749 13.1067C14.8749 11.726 13.7556 10.6067 12.3749 10.6067C10.9942 10.6067 9.87491 11.726 9.87491 13.1067C9.87491 13.775 10.1372 14.3821 10.5644 14.8307L12.3721 17.0308L14.1429 14.8742Z",
    fill: "#404553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 14.8742L13.6125 14.344L13.5865 14.3699L13.5632 14.3983L14.1429 14.8742ZM10.5644 14.8307L11.1439 14.3545L11.1264 14.3333L11.1075 14.3134L10.5644 14.8307ZM12.3721 17.0308L11.7926 17.5069L12.3723 18.2125L12.9518 17.5068L12.3721 17.0308ZM14.6733 15.4045C15.2604 14.8172 15.6249 14.0038 15.6249 13.1067H14.1249C14.1249 13.5901 13.9299 14.0265 13.6125 14.344L14.6733 15.4045ZM15.6249 13.1067C15.6249 11.3118 14.1698 9.85669 12.3749 9.85669V11.3567C13.3414 11.3567 14.1249 12.1402 14.1249 13.1067H15.6249ZM12.3749 9.85669C10.58 9.85669 9.12491 11.3118 9.12491 13.1067H10.6249C10.6249 12.1402 11.4084 11.3567 12.3749 11.3567V9.85669ZM9.12491 13.1067C9.12491 13.9752 9.46659 14.7655 10.0213 15.3479L11.1075 14.3134C10.8078 13.9987 10.6249 13.5749 10.6249 13.1067H9.12491ZM12.9516 16.5547L11.1439 14.3545L9.98492 15.3068L11.7926 17.5069L12.9516 16.5547ZM13.5632 14.3983L11.7925 16.5549L12.9518 17.5068L14.7225 15.3502L13.5632 14.3983Z",
    fill: "#404553"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3749 14.6067C13.2033 14.6067 13.8749 13.9351 13.8749 13.1067C13.8749 12.2783 13.2033 11.6067 12.3749 11.6067C11.5465 11.6067 10.8749 12.2783 10.8749 13.1067C10.8749 13.9351 11.5465 14.6067 12.3749 14.6067Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6273 5.75794C2.62209 4.09904 3.96544 2.75146 5.62435 2.75146H21.1256L21.1222 7.25146H4.12553C3.29992 7.25146 2.6299 6.58355 2.6273 5.75794Z",
    fill: "#FEEE00",
    stroke: "#404553",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAddresses);
export default __webpack_public_path__ + "static/media/accountAddresses.c677fdfe.svg";
export { ForwardRef as ReactComponent };